/**
 * POST `admin/tariffs/solo` — новая версия соло-тарифа (ADMIN_BACKEND §5.2).
 * Версия не перезаписывает прошлую (основание для проведённых платежей),
 * применяется со следующего продления. Цена уезжает в тыйынах.
 */

import {apiEnabled, http} from '@services/utils';

import {applySoloVersionMock} from '../mocks';
import type {SaveSoloInput, SaveSoloResult} from '../types';

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export const saveSoloTariff = async (input: SaveSoloInput): Promise<SaveSoloResult> => {
  if (!apiEnabled) {
    await sleep(700);
    return {ok: true, version: applySoloVersionMock(input.price)};
  }

  const raw = await http<Record<string, unknown>>('admin/tariffs/solo', {
    method: 'POST',
    body: {priceTiyin: Math.round(input.price * 100)},
    skipCaseConversion: true,
  });
  return {ok: true, version: typeof raw.version === 'number' ? raw.version : 0};
};
